import { css } from '@linaria/atomic';
import { ContainedIcon } from '@frontend/icons';
import { theme } from '@frontend/theme';

const criticalContainedIconStyle1 = css`
  padding: 2px;
  border-radius: var(--fabric-radius-sm);
`;

export const Critical = ({ as = 'span' }: { as?: React.ElementType }) => {
  return (
    <ContainedIcon
      as={as}
      className={criticalContainedIconStyle1}
      iconName='ai-critical'
      background={theme.colors.gradients.critical}
      color={theme.colors.critical70}
    />
  );
};
